export default class IntermediateControlJsonReader {
    read(json) {
        const ic = {};
        ic.controlName = json.cn;
        ic.displayName = json.dn;
        ic.sequence = json.s;
        return ic;
    }
}
